(() => {
  'use strict';

  const SUPPORT_EMAIL = 'support@onlyvisioncounts.com';
  const POLICY_LINKS = new Map([
    ['/policies/refund-policy', '/pages/returns-refunds'],
    ['/policies/shipping-policy', '/pages/shipping-delivery']
  ]);
  const legacyEmailPattern = /(?:mldropassist|onlyvisioncount|onlyvisioncountsreturns|onlyvisioncountsorders)@gmail\.com/gi;
  const freeShippingPatterns = [
    /free shipping/i,
    /kostenlos(?:er|e|en)? versand/i,
    /gratis versand/i,
    /livraison gratuite/i,
    /gratis verzending/i,
    /env[ií]o gratis/i,
    /spedizione gratuita/i
  ];

  function redirectLegacyPolicyPath() {
    const destination = POLICY_LINKS.get(window.location.pathname.replace(/\/$/, ''));
    if (destination && destination !== window.location.pathname) window.location.replace(destination);
  }

  function removeInaccurateShippingClaims(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.countdown-container').forEach((element) => element.remove());
    scope.querySelectorAll('ul.l4al.inline').forEach((element) => {
      const text = element.textContent || '';
      if (freeShippingPatterns.some((pattern) => pattern.test(text))) element.remove();
    });
  }

  function rewriteLinks(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const anchors = [];
    if (root && root.nodeType === 1 && root.matches?.('a[href]')) anchors.push(root);
    anchors.push(...scope.querySelectorAll('a[href]'));

    anchors.forEach((anchor) => {
      const rawHref = anchor.getAttribute('href') || '';
      if (!rawHref) return;

      if (/^mailto:/i.test(rawHref) && legacyEmailPattern.test(rawHref)) {
        anchor.setAttribute('href', `mailto:${SUPPORT_EMAIL}`);
      }
      legacyEmailPattern.lastIndex = 0;

      try {
        const url = new URL(rawHref, window.location.origin);
        const destination = POLICY_LINKS.get(url.pathname.replace(/\/$/, ''));
        if (destination) anchor.setAttribute('href', destination);
      } catch (_) {
        // Ignore malformed or non-navigation URLs.
      }
    });
  }

  function replaceLegacyText(root) {
    if (!root || ![1, 9, 11].includes(root.nodeType)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      if (!node.parentElement || node.parentElement.closest('script, style, textarea, noscript')) return;
      let text = node.nodeValue || '';
      text = text.replace(legacyEmailPattern, SUPPORT_EMAIL);
      legacyEmailPattern.lastIndex = 0;
      text = text.replace(/\bML\s*DRIP\b/gi, 'Only Vision Counts');
      text = text.replace(/\bMLDROP\b/gi, 'Only Vision Counts');
      text = text.replace(/\[INSERT TRADING NAME\]/gi, 'Only Vision Counts');
      text = text.replace(/\[INSERT BUSINESS ADDRESS\]/gi, 'Germany');
      text = text.replace(/\[INSERT BUSINESS PHONE NUMBER\]/gi, 'Customer support is available by email');
      text = text.replace(/\[INSERT BUSINESS REGISTRATION NUMBER\]/gi, '');
      text = text.replace(/\[INSERT VAT NUMBER\]/gi, '');
      if (text !== node.nodeValue) node.nodeValue = text;
    });
  }

  function clean(root) {
    removeInaccurateShippingClaims(root);
    rewriteLinks(root);
    replaceLegacyText(root);
  }

  function start() {
    redirectLegacyPolicyPath();
    clean(document);
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if ([1, 11].includes(node.nodeType)) clean(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();

(() => {
  'use strict';

  const CONTROL_SELECTOR = '.l4vw[aria-controls="collection"]';
  const VIEW_SELECTOR = '[data-collection_grid_view]';
  const WIDTH_CLASS_PATTERN = /^w\d+(?:-mobile)?$/;

  function getControls() {
    return [...document.querySelectorAll(CONTROL_SELECTOR)];
  }

  function getViewIcons(controls = getControls()) {
    return controls.flatMap((control) => [...control.querySelectorAll(VIEW_SELECTOR)]);
  }

  function getGridView(controls = getControls()) {
    const icons = getViewIcons(controls);
    return icons.find((icon) =>
      (icon.dataset.collection_grid_view || '').split(/\s+/).includes('w50-mobile')
    ) || icons[1] || null;
  }

  function applyView(view) {
    const productGrid = document.getElementById('collection');
    const controls = getControls();
    if (!productGrid || controls.length === 0 || !view) return;

    [...productGrid.classList]
      .filter((className) => WIDTH_CLASS_PATTERN.test(className))
      .forEach((className) => productGrid.classList.remove(className));

    view.split(/\s+/).filter(Boolean).forEach((className) => productGrid.classList.add(className));

    controls.forEach((control) => {
      control.querySelectorAll('li').forEach((item) => item.classList.remove('active'));
      const selectedIcon = [...control.querySelectorAll(VIEW_SELECTOR)].find(
        (icon) => icon.dataset.collection_grid_view?.trim() === view.trim()
      );
      selectedIcon?.closest('li')?.classList.add('active');
    });
  }

  function disableGridLinkNavigation(controls = getControls()) {
    controls.forEach((control) => {
      control.querySelectorAll('a').forEach((anchor) => {
        if (!anchor.querySelector(VIEW_SELECTOR)) return;
        anchor.removeAttribute('href');
        anchor.setAttribute('role', 'button');
        anchor.setAttribute('tabindex', '0');
      });
    });
  }

  function prepareCollectionGrid() {
    if (window.general?.template && window.general.template !== 'collection') return;
    const controls = getControls();
    const gridIcon = getGridView(controls);
    const gridView = gridIcon?.dataset.collection_grid_view?.trim();
    if (!gridView) return;

    disableGridLinkNavigation(controls);
    applyView(gridView);
  }

  function handleGridControl(event) {
    const anchor = event.target.closest?.(`${CONTROL_SELECTOR} a`);
    const icon = anchor?.querySelector(VIEW_SELECTOR);
    const view = icon?.dataset.collection_grid_view?.trim();
    if (!anchor || !view) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    applyView(view);
  }

  function handleGridKeyboard(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const anchor = event.target.closest?.(`${CONTROL_SELECTOR} a`);
    const icon = anchor?.querySelector(VIEW_SELECTOR);
    const view = icon?.dataset.collection_grid_view?.trim();
    if (!anchor || !view) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    applyView(view);
  }

  function collectionUiWasAdded(node) {
    if (!node || node.nodeType !== 1) return false;
    return Boolean(
      node.matches?.(`#collection, ${CONTROL_SELECTOR}`) ||
      node.querySelector?.(`#collection, ${CONTROL_SELECTOR}`)
    );
  }

  function startCollectionGridFix() {
    prepareCollectionGrid();
    document.addEventListener('click', handleGridControl, true);
    document.addEventListener('keydown', handleGridKeyboard, true);

    new MutationObserver((records) => {
      const collectionUiChanged = records.some((record) =>
        [...record.addedNodes].some(collectionUiWasAdded)
      );
      if (collectionUiChanged) requestAnimationFrame(prepareCollectionGrid);
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', startCollectionGridFix, { once: true })
    : startCollectionGridFix();

  window.addEventListener('pageshow', prepareCollectionGrid);
  document.addEventListener('shopify:section:load', prepareCollectionGrid);
})();